import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container mt-6" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", { class: "title" }, "Create new Day Template", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Create "),
  /*#__PURE__*/_createVNode("strong", null, "Day Templates"),
  /*#__PURE__*/_createTextVNode(" to easily manage "),
  /*#__PURE__*/_createVNode("strong", null, "Work Periods"),
  /*#__PURE__*/_createTextVNode(" in your timeline! ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_day_periods_picker = _resolveComponent("day-periods-picker")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createVNode(_component_day_periods_picker, {
        "submit-text": "Create Template",
        onSubmit: _ctx.onCreateTemplate,
        "is-submit-loading": _ctx.isLoading,
        "with-template-name": ""
      }, null, 8, ["onSubmit", "is-submit-loading"])
    ])
  ]))
}